import Message from '../message';

/**
 * Create the action
 */

const { thunk, request, success, error } = Message.store((data, fetch) => {

    if (data.fromSocket) {
        return Promise.resolve({ data })
    }

    const endpoint = data.isCheckIn ? '/messages/check-in' : '/messages';

    // Prepare request
    let formData = new FormData();
    ['target_type', 'target_id', 'message_type', 'message_data', 'project_id']
        .map(key => data[key] !== undefined ? formData.append(key, data[key]) : null);
    
    return fetch.post(endpoint, formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };